import React, { useState, useEffect } from 'react';
import FileUploadManager from './FileUploadManager';
import { List } from 'antd';
import dayjs from 'dayjs';
import { mixGetV2 } from '../../../services/mixin';


const ImportDataStep1 = ({ stData = {} as any, onChange = (data = {}, type = null) => { } }) => {
  const [listTemplate, setListTemplate] = useState([] as any)
  const [paramTemplate, setParamTemplate] = useState({
    'sort[]': 'id,desc',
    page: 1,
    limit: 100000,
    name: '',
  })
  let wait = false
  const getTemplate = async () => {
    if (wait) {
      return
    }
    wait = true
    const res = await mixGetV2('/api/v1/be/template_excels', paramTemplate)
    wait = false
    if (res.status) {
      setListTemplate([...res.data.items])
    }
  }

  useEffect(() => {
    getTemplate()
  }, [paramTemplate])
  return (
    <div className="import-page">
      {/* Vùng upload bên trái */}
      <div style={{ flex: 1 }}>
        <FileUploadManager importHistory={stData.importHistory} stData={stData} onChange={(data) => {
          onChange(data, null);
        }} />
      </div>

      {/* Sidebar bên phải */}
      <div className='mw-450'>
        <div className="p-16-20-8-F2F4F7 mb-16 list-template-sidebar">
          <div className='title'>File mẫu</div>
          <List
            size="small"
            dataSource={listTemplate}
            renderItem={(item: any) => (
              <List.Item>
                <div className='one-item' onClick={async () => {
                  const selectedItems = JSON.parse(item.data_json || '[]');
                  const XLSX = await import('xlsx');
                  const header = selectedItems.map((item: any) => item.text);
                  const ws = XLSX.utils.aoa_to_sheet([header]);
                  const wb = XLSX.utils.book_new();
                  XLSX.utils.book_append_sheet(wb, ws, "Template");
                  XLSX.writeFile(wb, `${item.name || 'template'}.xlsx`);
                }}>
                  <div className="icon-svg">
                    <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1.21875 7.77832C1.28729 7.77851 1.34368 7.83475 1.34375 7.90332V10.3096H10.6562V7.90332C10.6563 7.83463 10.7125 7.77832 10.7812 7.77832H11.7188C11.7873 7.77851 11.8437 7.83475 11.8438 7.90332V10.9971C11.8438 11.2735 11.6201 11.4969 11.3438 11.4971H0.65625C0.379687 11.4971 0.15625 11.2736 0.15625 10.9971V7.90332C0.156325 7.83463 0.212546 7.77832 0.28125 7.77832H1.21875ZM6.4668 0.49707C6.5355 0.49707 6.59172 0.553382 6.5918 0.62207V5.91016H7.75C7.85446 5.91043 7.91165 6.03017 7.84766 6.11133L6.09766 8.3252C6.08606 8.33997 6.07155 8.35207 6.05469 8.36035C6.03774 8.36861 6.01885 8.37299 6 8.37305C5.98111 8.37305 5.96231 8.36859 5.94531 8.36035C5.92826 8.35204 5.91306 8.34014 5.90137 8.3252L4.15137 6.10938C4.08746 6.02813 4.14537 5.9082 4.25 5.9082H5.4043V0.62207C5.40437 0.553393 5.46061 0.497089 5.5293 0.49707H6.4668Z" fill="#096DD9" />
                    </svg>
                  </div>
                  <div className="name">{item.name}</div>
                </div>
              </List.Item>
            )}
          />
        </div>

        <div className="p-16-20-8-F2F4F7 pr-12 list-import-sidebar">
          <div className='title'>Lịch sử import</div>
          <List
            className='list-item-ls'
            dataSource={stData.importHistory}
            renderItem={(item: any) => (
              <List.Item>
                <div className="one-item">
                  <div className="icon-svg">
                    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd" clipRule="evenodd" d="M6.14461 0H14.1767L20.9738 7.09489V20.873C20.9738 22.5985 19.5811 24 17.8556 24H6.14461C4.42782 24 3.02637 22.5985 3.02637 20.873V3.11824C3.02634 1.40145 4.42782 0 6.14461 0Z" fill="#00733B" />
                      <path opacity="0.3" fillRule="evenodd" clipRule="evenodd" d="M14.168 0V7.03358H20.9738L14.168 0Z" fill="white" />
                      <path d="M10.4895 17.4744H9.32452L8.52745 16.1343L7.73036 17.4744H6.55664L7.94059 15.1445L6.72309 13.1211H7.89678L8.52742 14.1722L9.14931 13.1211H10.323L9.11425 15.1533L10.4895 17.4744ZM10.9012 17.4744V13.1211H12.0136V16.5284H13.9055V17.4744H10.9012V17.4744ZM15.7449 17.527C15.307 17.527 14.9216 17.3868 14.5888 17.1153C14.2647 16.8525 14.0807 16.5197 14.0544 16.1255L15.0092 15.8452C15.0355 16.0555 15.1231 16.2394 15.272 16.3796C15.4296 16.5197 15.6048 16.5898 15.7975 16.5898C15.9552 16.5898 16.0866 16.5547 16.1917 16.4847C16.288 16.4146 16.3406 16.3182 16.3406 16.2044C16.3406 16.108 16.2968 16.0292 16.2179 15.9591C16.1391 15.8978 16.034 15.8452 15.9114 15.8015C15.7887 15.7577 15.6398 15.7139 15.4909 15.6788C15.3333 15.635 15.1756 15.5825 15.0267 15.5124C14.869 15.4511 14.7289 15.3723 14.6063 15.2759C14.4749 15.1883 14.3785 15.0569 14.2997 14.8905C14.2208 14.7328 14.177 14.5401 14.177 14.3212C14.177 13.962 14.3259 13.6642 14.6325 13.4277C14.9391 13.1825 15.307 13.0686 15.7362 13.0686C16.1654 13.0686 16.542 13.1737 16.8573 13.3752C17.1727 13.5854 17.3741 13.8569 17.4529 14.1898L16.4544 14.6102C16.4106 14.4263 16.323 14.2774 16.2004 14.1635C16.0777 14.0584 15.9201 13.9971 15.7362 13.9971C15.596 13.9971 15.4909 14.0321 15.4033 14.0847C15.3245 14.1372 15.2894 14.2161 15.2894 14.3124C15.2894 14.4 15.342 14.4788 15.4471 14.5402C15.5522 14.5927 15.6924 14.6365 15.85 14.6628C16.0077 14.6891 16.1829 14.7329 16.3668 14.7942C16.5595 14.8643 16.7259 14.9343 16.8923 15.0307C17.05 15.1183 17.1814 15.2672 17.2865 15.4599C17.4004 15.6614 17.4529 15.8979 17.4529 16.1694C17.4529 16.5723 17.2953 16.9052 16.9799 17.1504C16.6646 17.3956 16.253 17.527 15.7449 17.527Z" fill="white" />
                    </svg>

                  </div>
                  <div className="right-content">
                    <div className="title-file">{item.name}</div>
                    <div className="description">
                      <div className="date">{`${dayjs(item.updated_at).format('DD/MM/YYYY')}`}</div>
                      <div className='cl-blue'></div>
                      <div className='user'>{`${item.user}`}</div>
                      {/* <div className="fz-blue">(NV839)</div> */}
                    </div>
                  </div>
                </div>
              </List.Item>
            )}
          />
        </div>
      </div>
    </div>
  );
};

export default ImportDataStep1;
